import * as constants from './constants';

const generalInitialState = {
  cities: null,
  provinces: null,
  brands: null,
  models: null,
  years: null,
};

const generalReducer = (
  state = generalInitialState,
  { type, payload } = {},
) => {
  switch (type) {
    case constants.GET_PROVINCES:
      return {
        ...state,
        provinces: payload,
      };
    case constants.GET_CITIES:
      return {
        ...state,
        cities: { ...state.cities, ...payload },
      };
    case constants.GET_BRAND:
      return {
        ...state,
        brands: payload,
      };
    case constants.GET_MODEL:
      return {
        ...state,
        models: { ...state.models, ...payload },
      };
    case constants.GET_YEARS_OF_MODEL:
      return {
        ...state,
        years: { ...state.years, ...payload },
      };
    case constants.UPDATE_MODAL:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};

export default generalReducer;
